/**
 * CVR Size Memory
 * PDPで選んだバリエーション(option1: 色, option2: サイズ等)をlocalStorageに記録、
 * 次回同一商品訪問時に自動再選択。
 * 商品ハンドル単位で保存・サイトワイドで「最後に選んだサイズ」もキャッシュして
 * 別商品でも同じサイズが存在する場合は事前選択を提案。
 */
(function () {
  'use strict';

  var PER_PRODUCT_KEY = 'cvr_pdp_variant_v1';
  var LAST_SIZE_KEY = 'cvr_last_size_v1';

  function readJSON(key) {
    try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
  }
  function writeJSON(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function readStr(key) {
    try { return localStorage.getItem(key) || ''; } catch (e) { return ''; }
  }
  function writeStr(key, val) {
    try { localStorage.setItem(key, val); } catch (e) {}
  }

  function getHandleFromPath() {
    var m = location.pathname.match(/\/products\/([^/?]+)/);
    return m ? m[1] : '';
  }

  function findVariantPicker() {
    return document.querySelector('variant-selects, variant-radios, [data-variant-picker]');
  }

  function getSelectedOptions(picker) {
    if (!picker) return {};
    var opts = {};
    var inputs = picker.querySelectorAll('input[type="radio"]:checked, select');
    inputs.forEach(function (el) {
      var name = el.getAttribute('data-option-name') || el.getAttribute('name') || '';
      var value = '';
      if (el.tagName === 'SELECT') value = el.value;
      else if (el.checked) value = el.value;
      if (name && value) opts[name] = value;
    });
    return opts;
  }

  function isSizeOptionName(name) {
    if (!name) return false;
    var n = String(name).toLowerCase();
    return n.indexOf('size') >= 0 || n.indexOf('サイズ') >= 0;
  }

  function applyOptions(picker, options) {
    if (!picker || !options) return false;
    var changed = false;
    Object.keys(options).forEach(function (name) {
      var value = options[name];
      if (!value) return;
      // radio
      var radio = picker.querySelector('input[type="radio"][value="' + CSS.escape(value) + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
        return;
      }
      // select by name match
      var selects = picker.querySelectorAll('select');
      selects.forEach(function (sel) {
        var oname = sel.getAttribute('data-option-name') || sel.getAttribute('name') || '';
        if (oname === name && sel.value !== value) {
          var hasOpt = Array.from(sel.options).some(function (o) { return o.value === value; });
          if (hasOpt) {
            sel.value = value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            changed = true;
          }
        }
      });
    });
    return changed;
  }

  function rememberOnChange(handle, picker) {
    if (!picker || !handle) return;
    var save = function () {
      var opts = getSelectedOptions(picker);
      if (Object.keys(opts).length === 0) return;
      var all = readJSON(PER_PRODUCT_KEY);
      all[handle] = opts;
      writeJSON(PER_PRODUCT_KEY, all);
      // Save last-known size as separate key for cross-product hint
      Object.keys(opts).forEach(function (name) {
        if (isSizeOptionName(name)) writeStr(LAST_SIZE_KEY, opts[name]);
      });
    };
    picker.addEventListener('change', save, true);
    // Initial save (in case URL has variant param)
    setTimeout(save, 600);
  }

  function restore(handle, picker) {
    if (!picker || !handle) return;
    var all = readJSON(PER_PRODUCT_KEY);
    if (all[handle]) {
      applyOptions(picker, all[handle]);
      return;
    }
    // Cross-product size hint
    var lastSize = readStr(LAST_SIZE_KEY);
    if (lastSize) {
      var radio = picker.querySelector('input[type="radio"][value="' + CSS.escape(lastSize) + '"]');
      if (radio && !radio.checked && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function init() {
    if (!/\/products\//.test(location.pathname)) return;
    var handle = getHandleFromPath();
    var picker = findVariantPicker();
    if (!picker) {
      // Retry once after Foxtheme components mount
      setTimeout(function () {
        var p = findVariantPicker();
        if (p) { restore(handle, p); rememberOnChange(handle, p); }
      }, 500);
      return;
    }
    restore(handle, picker);
    rememberOnChange(handle, picker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
